import { observer } from 'mobx-react'

import { HelpIcon, Money, TooltipText } from '../../../../components'
import { SectionHeader, SectionBalance } from './InvestmentRowStyle'
import InvestmentRows from './InvestmentRows'

const InstitutionalInvestmentsGroup = props => {
  const { title, balanceLabel, balance, investments, hideBalance, showCostBasisHelp } = props

  return (
    <div>
      <SectionHeader>
        <div>
          {title} {showCostBasisHelp && <HelpIcon tooltip={TooltipText.costBasis()} />}
        </div>
        {!hideBalance && (
          <SectionBalance>
            {balanceLabel && `${balanceLabel} `}
            <Money value={balance} />
          </SectionBalance>
        )}
      </SectionHeader>

      <InvestmentRows
        accountId={props.accountId}
        canEdit={props.canEdit}
        hideBalance={hideBalance}
        investments={investments}
        toggleEdit={props.toggleEdit}
      />
    </div>
  )
}

export default observer(InstitutionalInvestmentsGroup)
